import { __assign, __rest } from "tslib";
import React from 'react';
import { twMerge } from 'tailwind-merge';
export var Card = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({}, rest, { className: twMerge('p-4 rounded-default w-full text-left bg-white border border-alto', rest.onClick &&
            'cursor-pointer shadow-[0px_1px_4px_rgba(114,114,114,0.15)] hover:shadow-[2px_2px_12px_rgba(114,114,114,0.25)]', className) }), children));
};
